import { get } from 'lodash-es'

import { request } from '@/common/utils/request'

export default {
  /** 关联门店 **/
  setContractor: data => {
    return request.post({
      url: 'crm.open.apply.setContractor',
      data
    })
  },
   /** 解绑关联门店 **/
  delContractor: data => {
    return request.post({
      url: 'crm.append.apply.delContractor',
      data
    })
  },
  /** 关联门店提交至审批 **/
  submitGlobal: data => {
    return request.post({
      url: 'crm.contractor.apply.submitGlobal',
      data
    })
  },
  /** 获取关联的门店 **/
  getBindShop: params => {
    return request.get({
      url: 'crm.contractor.apply.getBindShop',
      params
    })
  },
   /** 门店检索 **/
  getNameSug: params => {
    return request.get({
      url: 'crm.contractor.bizopp.getNameSug',
      ...params
    })
  },
   // list
  getContractorList: params => {
    return request.get({
      url: 'crm.contractor.getList',
      ...params
    })
  },

  fetchBizoppNameSug: params => {
    return request.get({
      url: 'crm.bdapp.bizopp.getNameSug',
      ...params
    })
  },

  bizoppUpdateTags: params => {
    return request.post({
      url: 'crm.bdapp.bizopp.updateTags',
      params: params
    })
  },
  /*
   * 根据POI选择城市
   */
  getCityIdByPoi: params => {
    return request.get({
      url: 'crm.bdapp.index.common.getCityIdByPoi',
      params: params
    })
  },
  /*
   * 根据国家选择品类
   */
  getCategoryByCountry: params => {
    return request.get({
      url: 'crm.bdapp.bizopp.getCategoryByCountry',
      params: params
    })
  },

  add: params => {
    return request.post({
      url: 'crm.bdapp.bizopp.addApply',
      ...params
    })
  },

  update: params => {
    return request.post({
      url: 'crm.bdapp.bizopp.update',
      ...params
    })
  },

  getBizoppInfo: params => {
    return request.get({
      url: 'crm.bdapp.bizopp.getBizoppInfo',
      ...params
    })
  },

  getMyFaildeBizoppInfo: params => {
    return request.get({
      url: 'crm.bdapp.bizopp.getApplyBizoppInfo',
      params: params
    })
  },

  /**
   * sign 签约部分
   */
  getSignDetail: data => {
    return request.post({
      url: 'crm.bdapp.open.apply.get',
      data
    })
  },

  getContractInfo: data =>
    request.post({
      url: 'crm.bdapp.open.apply.get',
      data
    }),

  getCommonApplyBaseInfo (params) {
    return request.get({
      url: 'crm.bizopp.bizopp.getCommonApplyBaseInfo',
      params
    })
  },
  getSignAudit: data =>
    request.post({
      url: 'crm.bdapp.open.apply.get',
      data
    }),

  saveSignDetail: data =>
    request.post({
      url: 'crm.bdapp.open.apply.update',
      data
    }),

  submitSignDetail: data => {
    return request
      .post({
        url: 'crm.bdapp.open.apply.submitGlobal',
        data
      })
  },

  getSignShopAudit: data => {
    return request
      .post({
        url: 'crm.bdapp.open.apply.get',
        data
      })
      .then(res => {
        return get(res, 'data.auditGlobal', {})
      })
  },
  getCommonConfig: params => {
    return request
      .get({
        url: 'crm.common.getConfig',
        params
      })
  },

  fetchSignListOpenCityList: (params) => {
    return request.get({
      url: 'crm.index.common.getOpenCityList',
      ...params
    })
  }
}
